<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">{{data.title}}</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
        @if(data.line1 != ''){
            {{data.line1}}
        }
        
        @if(data.line2 != ''){
            <br />
            <br />
            {{data.line2}}
        }
    </div>
    
</div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;">
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial style="background-color:#003087 !important;color:white !important">{{data.button}}</button>
</div>

